export const reservationDrawer = {
  title: "تفاصيل الحجز",
  openFullPage: "فتح في صفحة كاملة",
  close: "إغلاق",
};
